import React from "react";
import "./ProductCardsModems.css";
import { Link } from "react-router-dom"; 
import '../i18n';
import { useTranslation } from 'react-i18next';

import Spin26H_USBL from './product_cards/Spin26H_USBL'
import Spin26H from './product_cards/Spin26H'

const ProductCardsSystem2Example = () => {
  const { t, i18n } = useTranslation();
  
  return (
    <div className="Products">
      <div class="card-list-modems">
        
        <Spin26H_USBL />
        <Spin26H />

      </div>
    </div>
  );
};
export default ProductCardsSystem2Example;